import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { getLabel } from 'utils/widgetTypeUtil'
import PlaceHolder from '../../../../share/PlaceHolder'
import Table from '../../share/Table'
import RunSearchEffect from '../../share/RunSearchEffect'
import { TopicNotSelectedGuard, WidgetLoadingGuard } from '../../../share/guards'
import WordCloudWidgetDataGuards from '../../share/guards/WordCloudWidgetDataGuards'
import { useDashboardWidgetSetting } from '../../../../../hooks/useDashboardState'
import { SocialWebPhotoConceptsWidget } from '../../../../../schemas/SocialWebPhotoConceptsWidgetSchema'
import { getMeasureByCountTypeAndAnalysisType } from '../../../../../utils/measureUtil'
import useSelectedInsights from '../InsightModal/hooks/useSelectedInsights'
import InsightModal from '../InsightModal'

interface TableDisplayProps {
  widgetId: number
}

const TableDisplay = ({ widgetId }: TableDisplayProps) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebPhotoConceptsWidget>(widgetId)
  const {
    isModalOpen,
    selectedInsights,
    onClick,
    onClose,
    detailSetting,
    widgetSettingWithSelection
  } = useSelectedInsights(widgetSetting)

  return (
    <ErrorBoundary FallbackComponent={({ error }) => <PlaceHolder>{error.message}</PlaceHolder>}>
      <TopicNotSelectedGuard widgetId={widgetId}>
        <RunSearchEffect
          widgetId={widgetId}
          measure={getMeasureByCountTypeAndAnalysisType(
            widgetSetting.countType!,
            widgetSetting.analysisType!
          )}
          imageAnalysis>
          <WidgetLoadingGuard widgetId={widgetId}>
            <WordCloudWidgetDataGuards widgetId={widgetId}>
              <Table
                widgetId={widgetId}
                onRowClick={(tableSelection) => {
                  onClick(tableSelection.insight)
                }}
              />
            </WordCloudWidgetDataGuards>
          </WidgetLoadingGuard>
        </RunSearchEffect>
      </TopicNotSelectedGuard>
      <InsightModal
        open={isModalOpen}
        onClose={onClose}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        selectedInsights={selectedInsights}
        detailSetting={detailSetting}
        widgetSettingWithSelection={widgetSettingWithSelection}
      />
    </ErrorBoundary>
  )
}

export default TableDisplay
